import React from "react";
import resolveLink from 'src/utils/resolveLink'
import Heading from 'src/components/Heading'
import RichText from 'src/utils/RichText'
import { useForm } from "react-hook-form";
import { navigate } from "gatsby";
import SbEditable from "storyblok-react";

import TextInput from "./Forms/Components/TextInput"
import EmailInput from "./Forms/Components/EmailInput";
import TextAreaInput from "./Forms/Components/TextAreaInput";
import FileInput from "./Forms/Components/FileInput";
import NumberInput from "./Forms/Components/NumberInput";
import SelectInput from "./Forms/Components/SelectInput";
import RadioButtons from "./Forms/Components/RadioButtons";
import ConsentInput from "./Forms/Components/ConsentInput";

const Components = {
    "text-input": TextInput,
    "email-input": EmailInput,
    "textarea-input": TextAreaInput,
    "file-input": FileInput,
    "number-input": NumberInput,
    "select-input": SelectInput,
    "radio-buttons": RadioButtons,
    "consent-input": ConsentInput
}

const Form = ({ blok }) => {

    const { register, handleSubmit, formState: { errors } } = useForm();

    function encode(data) {
        const formData = new FormData();
        for (const [key, value] of Object.entries(data)) {
            if( typeof value === 'object' ) {
                formData.append(key, value[0]);
            } else {
                formData.append(key, value);
            }
        }
        return formData;
    }

    const onSubmit = (data) => {
        fetch("/", {
          method: "POST",
          body: encode(data),
        })
        .then(() => {
            window?.dataLayer?.push({event: 'form-submission', formName: blok.name});
            navigate(resolveLink(blok.action.cached_url))
        })
        .catch((error) => console.log(error));
    };

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                <div>
                    { blok.title && <Heading size="h2">{blok.title}</Heading>}
                    { blok.description && 
                        <div className="prose md:text-base text-sm">
                            <RichText>{blok.description}</RichText>
                        </div>
                    }
                    <form onSubmit={handleSubmit(onSubmit)} name={blok.name} id={blok.name} className="mt-12 flex flex-col" data-netlify="true">
                        <div className="grid grid-cols-6 gap-x-4">
                            {blok.fields.map((field, index) => {
                                const Component = Components[field.component];
                                return <Component blok={field} register={register} errors={errors} key={index} />;
                            })}
                        </div>
                        <input {...register("form-name")} type="hidden" name="form-name" value={blok.name} />
                        <button type="submit" className="cursor-pointer inline-flex justify-center items-center px-5 py-3 line-crop font-display text-white uppercase transition duration-300 text-lg !leading-tight bg-red hover:bg-darkred self-start">{blok.button_text}<i className="fas fa-chevron-right cursor-pointer ml-3 text-xs inline"></i></button>
                    </form>
                </div>
            </div>
        </SbEditable>
    )
}

export default Form